import React, { Component } from 'react';
import { Icon, Segment, Step, Button, Modal, Label, Divider } from 'semantic-ui-react';

const ACCOUNT_STEP = 'account';
const LINK_STEP = 'link';
const AUTHORISE_STEP = 'authorise';

const segmentContentStyle = {
  paddingBottom: 25,
};

const segmentStyle = {
  border: 'none',
  margin: 0,
  width: '100%',
  minHeight: 240,
  paddingTop: 15,
};

const textAlignCenter = {
  textAlign: 'center',
};

const dyzioRedStyle = { color: '#ef3a50' };

const shouldRenderStep = (activeStep, step) => activeStep === step;

class InstagramAuthModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: ACCOUNT_STEP,
    };
  }

  moveToStep = step => this.setState({
    activeStep: step,
  })

  render() {
    const { onContinueButtonClick, onClose } = this.props;
    const { activeStep } = this.state;
    return (
      <Modal
        open
        closeOnEscape
        closeOnDimmerClick
        onClose={onClose}
        size="small"
      >
        <Step.Group attached="top" fluid>
          <Step
            active={shouldRenderStep(activeStep, ACCOUNT_STEP)}
          >
            <Icon name="instagram" color="pink" />
            <Step.Content>
              <Step.Title>Instagram Account</Step.Title>
              <Step.Description>Creator or Business?</Step.Description>
            </Step.Content>
          </Step>

          <Step
            disabled={shouldRenderStep(activeStep, ACCOUNT_STEP)}
            active={shouldRenderStep(activeStep, LINK_STEP)}
          >
            <Icon name="chain" color="green" />
            <Step.Content>
              <Step.Title>Facebook Link</Step.Title>
              <Step.Description>Link to Facebook</Step.Description>
            </Step.Content>
          </Step>

          <Step
            disabled={!shouldRenderStep(activeStep, AUTHORISE_STEP)}
            active={shouldRenderStep(activeStep, AUTHORISE_STEP)}
          >
            <Icon color="orange" name="unlock" />
            <Step.Content>
              <Step.Title>Authorise</Step.Title>
              <Step.Description>Let's do this!</Step.Description>
            </Step.Content>
          </Step>
        </Step.Group>

        {
          shouldRenderStep(activeStep, ACCOUNT_STEP) &&
          <Segment attached textAlign="center" style={segmentStyle}>
            <div style={segmentContentStyle}>
              <p>You must have either a </p>
              <br />
              <h3><Label basic color="blue" size="large"><Icon name="instagram" />Business Account</Label></h3>
              <p> or a </p>
              <h3><Label basic color="pink" size="large"><Icon name="instagram" />Creator Account</Label></h3>
              <br />
              <p>How do I convert to a <a href="https://help.instagram.com/2358103564437429" target="_blank">Creator Account?</a></p>
              <br />
              <div style={dyzioRedStyle}>
                <p>The authorisation won't work</p>
                <p>if your account is not correct!</p>
              </div>
            </div>

          </Segment>
        }

        {
          shouldRenderStep(activeStep, LINK_STEP) &&
          <Segment attached textAlign="center" style={segmentStyle}>
            <div style={segmentContentStyle}>
              <h3>Your Instagram account must be linked to your Facebook page.</h3>
              <br />
              <p>Instagram marketing data such as Reach and Impressions</p>
              <p>is provided by the Facebook Instagram API (Facebook own Instagram).</p>
              <br />
              <p>In order to fetch data your accounts must be linked.</p>
              <br />
              <p>How do I <a href="https://help.instagram.com/356902681064399" target="_blank">link my accounts?</a></p>
              <br />
              <div style={dyzioRedStyle}>
                <p>The authorisation won't work</p>
                <p>if your accounts are not linked!</p>
              </div>
            </div>
          </Segment>
        }

        {
          shouldRenderStep(activeStep, AUTHORISE_STEP) &&
          <Segment attached textAlign="center" style={segmentStyle}>
            <div style={segmentContentStyle}>
              <h3>Let's do this!</h3>
              <br />
              <p>Great, you have the right account and it's linked. Let's go!</p>

              <Divider />
              <h3>PLEASE NOTE: Required Permissions</h3>

              <p>We <strong>NEED</strong> all of the following permissions to fetch the data for your posts</p>
              <br />
              <div style={{ color: 'cornflowerblue' }}>
                <h4>manage_pages</h4>
                <h4>instagram_basic</h4>
                <h4>instagram_manage_insights</h4>
              </div>
              <br />
              <p><strong style={{ color: 'cornflowerblue' }}>manage_pages</strong> is required for us to generate a secure access token</p>
              <p>without this permission the token will not work!</p>
            </div>
          </Segment>
        }

        <Modal.Actions style={textAlignCenter}>
          {
            shouldRenderStep(activeStep, ACCOUNT_STEP) &&
            <Button
              onClick={() => this.moveToStep(LINK_STEP)}
              inverted
              color="pink"
              icon="check"
              content="I have the right account"
            />
          }
          {
            shouldRenderStep(activeStep, LINK_STEP) &&
            <Button
              onClick={() => this.moveToStep(AUTHORISE_STEP)}
              inverted
              color="pink"
              icon="check"
              content="My account is linked to my Facebook Page"
            />
          }
          {
            shouldRenderStep(activeStep, AUTHORISE_STEP) &&
            <Button
              content="Continue with Instagram"
              icon="instagram"
              color="instagram"
              onClick={onContinueButtonClick}
            />
          }
        </Modal.Actions>

      </Modal>);
  }
}

export default InstagramAuthModal;



/** WEBPACK FOOTER **
 ** ./src/components/instagram-auth-modal/index.js
 **/